import { Snackbar, SnackbarContent, useMediaQuery } from '@material-ui/core'
import ErrorLine from 'components/ErrorLine'
import Footer from 'components/Footer/Footer'
import Button from 'components/CustomButtons/Button.js'
import MuiAlert from '@material-ui/lab/Alert'
import HarmonizeHeader from 'components/Header/HarmonizeHeader'
import { getNFT } from 'controllers/NFTController'
import { getMessage } from 'controllers/SocialServiceController'
import { listenForAccountsChange } from 'eth/ethUtils'
import { getHarmonizeContract } from 'eth/ethUtils'
import { ethEnabled } from 'eth/ethUtils'
import { getETHRate } from 'eth/ethUtils'
import { listenForChainChange } from 'eth/ethUtils'
import { getAccountBalanceEth } from 'eth/ethUtils'
import { getEthFromGwei,getOptionsIsRunning } from 'eth/tokenUtils'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { updateNFT } from 'redux/actions/nftActions'
import { setNFTMessage } from 'redux/actions/nftActions'
import { resetNFT } from 'redux/actions/nftActions'
import { displayError } from 'util/screenUtils'
import { isVeryNarrow } from 'util/screenUtils'
import { getLocalPrice } from 'eth/ethUtils'
import DisplayNFTInfo from 'components/nft/DisplayNFTInfo'
import { isOwner } from 'eth/ethUtils'
import SetPrice from 'components/nft/SetPrice'
import { setPrice } from 'eth/ethUtils'
import { setTransactionInProgress } from 'redux/actions/displayActions'
import { getActualGasCost } from 'eth/ethUtils'
import { getDisplayError } from 'eth/tokenUtils'
import ModalDialog from 'components/ModalDialog'
import { tokenDisclaimer } from 'eth/tokenUtils'
import TimerProgress from 'components/mint/TimerProgress'
import TransactionCost from 'components/nft/TransactionCost'
import BlurDialog from 'components/utility/BlurDialog'
function Alert(props) {
    return <MuiAlert elevation={6} variant='filled' {...props} />
}
let harmonizeContract
export default function ManageNFT() {
    const { tokenId } = useParams()
    const veryNarrow = isVeryNarrow(useMediaQuery)
    const dispatch = useDispatch()
    const ACTION_TYPES = {
        NONE: { type: 0, label: 'None' },
        SET_PRICE: { type: 1, label: 'Set Price' }
    }
    const [action, setAction] = useState(ACTION_TYPES.NONE)
    const [actualGasCost, setActualGasCost] = useState()
    const { transactionInProgress } = useSelector((state) => state.display)
    const [nftOwner, setNftOwner] = useState(undefined)
    const [currentAccount, setCurrentAccount] = useState()
    const [ethBalance, setEthBalance] = useState()
    const [ethInCurrency, setEthInCurrency] = useState(0)
    const { currency } = useSelector(state => state.settings)
    const { name, price } = useSelector(state => state.nfts)

    const [tokenMessage, setTokenMessage] = useState()
    const [showSnack, setShowSnack] = useState(false)
    const [confirmAction, setConfirmAction] = useState(false)
    const [error, setError] = useState()
    const [contractIsRunning, setContractIsRunning] = useState(undefined)
    const history = useHistory()
    const displayHarmonizeError = (error) => {
        getDisplayError(error, setError)
    }
    const transactionInProgressContent = () => {
        return (
            <div style={{ height: '20vh', width: '100%', textAlign: 'center' }}>
                {tokenMessage && (
                    <h4 style={{ textAlign: 'center' }}>{tokenMessage}</h4>
                )}
                <TimerProgress label='Transaction in progress...' height={10} />
            </div>
        )
    }
    const displayTransactionInProgress = () => {
        if (transactionInProgress) {
            return <BlurDialog
                content={transactionInProgressContent}
                hideTitle hideHelp
                close={() => dispatch(setTransactionInProgress(false))}
            />
        }
    }

    const snackClose = () => {
        setShowSnack(false)
        //history.replace('/Vault')
    }
    const snackActionCompleted = () => {
        if (showSnack) {
            return (
                <Snackbar
                    anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                    open={showSnack} onClose={snackClose}>
                    <SnackbarContent
                        style={{ backgroundColor: 'blue', border: '1px solid white' }}
                        message={<div>
                            <b>Congratulations!</b> Your {action.label} has completed.
                            <TransactionCost
                                actualGasCost={actualGasCost}
                                action={action.label}
                                ethInCurrency={ethInCurrency}
                                ethBalance={ethBalance}
                            />
                        </div>}
                        action={<div style={{ cursor: 'pointer', color: 'gold' }}
                            onClick={snackClose}>
                            Close
                        </div>} />

                </Snackbar>
            )
        }
    }
    const actionCompleted = (receipt) => {
        console.log('actionCompleted', receipt)
        setTokenMessage('Your token action has completed.')
        dispatch(setTransactionInProgress(false))
        const gasCost = getActualGasCost(receipt)
        setActualGasCost(gasCost)
        setShowSnack(true)
    }
    const actionStarted = (txHash) => {
        console.log('actionStarted', txHash)
        setTokenMessage('Transaction started...')
        dispatch(setTransactionInProgress(true))
    }
    const actionFailed = (error) => {
        dispatch(setTransactionInProgress(false))
        displayHarmonizeError(error)
    }
    const takeAction = async () => {
        console.log(`Action ${action.label} in progress`, action)
        setTokenMessage(`Action ${action.label} in progress, please wait...`)
        dispatch(setTransactionInProgress(true))
        try {
            switch (action.type) {
                case ACTION_TYPES.SET_PRICE.type:
                    await setPrice(
                        tokenId,
                        price,
                        0,//tx fee
                        actionCompleted,
                        actionFailed,
                        actionStarted)
                    break
                default:
                    break
            }
        } catch (error) {
            console.error('action FAILED', error)
            displayHarmonizeError(error)
        }
    }
    const managePrice = () => {
        return (
            <div style={{
                display: 'flex', width: veryNarrow ?
                    '90vw' : '50vw', flexDirection: 'column',
                marginLeft: 'auto', marginRight: 'auto'
            }}>

                <SetPrice onAction={() => {
                    setAction(ACTION_TYPES.SET_PRICE)
                    setConfirmAction(true)
                }} />
            </div>
        )

    }
    const displayMain = () => {
        return (
            <>
                <HarmonizeHeader />
                <div style={{ paddingBottom: '5em' }}>
                    <ErrorLine error={error} />
                    <div style={{
                        display: 'flex', flexDirection: 'column',
                        width: '90vw', marginLeft: 'auto', marginRight: 'auto'
                    }}>
                        <h4 style={{ textAlign: 'center' }}>Manage NFT for {name}</h4>
                        <DisplayNFTInfo tokenId={tokenId} currentAccount={currentAccount}
                            accountBalance={ethBalance} />
                        {nftOwner ? managePrice() : nftOwner !== undefined ? <h4>You do not own this NFT</h4> : null}
                        <Button
                            color="info"
                            title='Go back'
                            style={{ cursor: 'pointer' }}
                            onClick={() => history.goBack()}>
                            Close
                        </Button>
                    </div>
                </div>
                <ModalDialog
                    title={`Confirm ${action.label}`}
                    message={tokenDisclaimer(`${action.label}`)}
                    close={() => {
                        setConfirmAction(false)
                    }}
                    open={confirmAction}
                    noLabel='No'
                    no={() => setConfirmAction(false)}
                    yesLabel='Yes'
                    yes={() => {
                        setConfirmAction(false)
                        takeAction()
                    }}
                />
                {displayTransactionInProgress()}
                {snackActionCompleted()}
                <Footer />
            </>
        )
    }

    const checkValidMinting = () => {
        if (contractIsRunning === false) {
            setError(`Harmonize contract is not running`)
        }
    }
    const getOptions = () => {
        if (harmonizeContract) {
            harmonizeContract.methods
                .options()
                .call()
                .then((opts) => {
                    setContractIsRunning(getOptionsIsRunning(opts))
                    checkValidMinting()
                })
        }
    }
    const setupEth = async () => {
        try {
            console.log('ManageNFT setupEth')
            harmonizeContract = getHarmonizeContract()
            const ethAccount = await ethEnabled()
            console.log(`getAccountAndAsset ${ethAccount}`)
            setCurrentAccount(ethAccount)
            if (ethAccount) {
                setCurrentAccount(ethAccount)
                const balance = await getAccountBalanceEth()
                setEthBalance(balance)
                getETHRate(currency).then(async (rate) => {
                    setEthInCurrency(rate)
                })
                listenForAccountsChange()
                listenForChainChange()
                getOptions()
                const ownsNft = await isOwner(tokenId)
                setNftOwner(ownsNft)
            }

        } catch (error) {
            console.error('setupEth error', error)
            if (error.code === -32002) {
                displayError({
                    message:
                        'There is a Metamask connection request waiting for your response. Please tap the Metamask icon to continue.',
                }, setError)
            } else {
                displayError(error, setError)
            }
        }
    }
    useEffect(() => {
        const fetchMessage = async () => {
            dispatch(resetNFT())
            try {
                const nft = await getNFT(tokenId)
                if (nft) {
                    console.log('ManageNFT got existing NFT', nft)
                    const { messageId,price } = nft
                    const priceInEth=getEthFromGwei(price)
                    const updatedNft={...nft,price:priceInEth}
                    console.log('...updated', updatedNft)
                    dispatch(updateNFT(updatedNft))
                    const socialServiceMessage = await getMessage(messageId)
                    dispatch(setNFTMessage(socialServiceMessage))
                }
            } catch (error) {
                if (error.status === 404) {
                    displayError({ message: 'This NFT not found in Harmonize' }, setError)
                } else {
                    displayError(error, setError)
                }
            }
            if (!currentAccount) {
                setupEth()
            } else {
                getOptions()
            }
        }

        fetchMessage()

    }, [])
    if (process.env.REACT_APP_MODE == 'development') {
        return displayMain()
    } else {
        return <div onContextMenu={(e) => e.preventDefault()}>{displayMain()}</div>
    }
}